// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-container h2 {
  text-align: center;
  margin-bottom: 20px;
}

.admin-container form {
  display: flex;
  flex-direction: column;
}

.admin-container label {
  margin-bottom: 5px;
  font-weight: bold;
}

.admin-container textarea,
.admin-container input,
.admin-container select {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.admin-container textarea {
  min-height: 150px;
  max-height: 350px;
  resize: vertical;
}

.admin-container textarea:focus,
.admin-container input:focus,
.admin-container select:focus {
  border-color: #007bff;
  outline: none;
}

.admin-container button {
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.admin-container button:hover {
  background-color: #0056b3;
}

.subscriptions-table-container {
    margin-top: 20px;
    overflow-x: auto;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.subscriptions-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    font-size: 12px;
}

.subscriptions-table th,
.subscriptions-table td {
    border: 1px solid #ddd;
    padding: 6px 8px;
    text-align: left;
}

.subscriptions-table th {
    position: sticky;
    top: 0;
    background-color: #f4f4f4;
    z-index: 1;
    font-size: 13px;
    font-weight: 600;
}

.subscriptions-table th:hover {
    background-color: #e4e4e4;
}

.subscriptions-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.subscriptions-table tr:hover {
    background-color: #f5f5f5;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 5px;
}

.pagination-button {
    padding: 8px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s;
    min-width: 40px;
    font-weight: 500;
}

.pagination-button:hover:not(:disabled) {
    background-color: #0059b9;
}

.pagination-button.active {
    background-color: #00356e;
    color: white;
    border-color: #007bff;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
    font-weight: bold;
}

.pagination-button.active:hover {
    background-color: #0056b3;
}

.pagination-button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.items-per-page {
    margin-left: 15px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
}

.action-buttons {
    white-space: nowrap;
    width: 80px;
}

.action-buttons button {
    padding: 4px 8px;
    margin: 0 2px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
}

.edit-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.edit-button:hover {
    background-color: #0056b3;
}

.save-button:hover {
    color: #28a745;
}

.cancel-button:hover {
    color: #dc3545;
}

.subscriptions-table input,
.subscriptions-table select {
    width: 100%;
    padding: 4px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.subscriptions-table input:focus,
.subscriptions-table select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}
.subscriptions-table td {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.editable-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.editable-row:hover {
    background-color: rgba(0, 123, 255, 0.05);
}

.editable-row td {
    -webkit-user-select: none;
            user-select: none; 
}

.subscriptions-table th:nth-child(1),
.subscriptions-table td:nth-child(1) {
    width: 80px;
    font-family: monospace;
    font-size: 12px;
    text-align: center;
}

.admin-layout {
    display: flex;
    min-height: 100vh;
    background-color: #f9f9f9;
}

.admin-nav {
    width: 250px;
    min-width: 250px;
    background-color: #f8f9fa;
    padding: 20px;
    border-right: 1px solid #dee2e6;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.admin-nav h2 {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
    color: #333;
    font-size: 1.5rem;
}

.nav-link {
    display: block;
    padding: 12px 15px;
    color: #333;
    text-decoration: none;
    border-radius: 4px;
    margin-bottom: 8px;
    transition: all 0.3s ease;
}

.nav-link:hover {
    background-color: #e9ecef;
}

.nav-link.active {
    background-color: #007bff;
    color: white;
}

.admin-content {
    flex: 1 1;
    padding: 30px;
    margin-left: 250px;
    width: calc(100% - 250px);
    box-sizing: border-box;
}

.settings-section,
.plans-section {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.settings-section h2,
.plans-section h2 {
    margin-bottom: 20px;
    color: #333;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 10px;
}

.plans-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 14px;
}

.plans-table th,
.plans-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #dee2e6;
}

.plans-table th {
    background-color: #f8f9fa;
    font-weight: 600;
}

.plans-table tr:hover {
    background-color: #f8f9fa;
}

.add-plan-form {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
}

.add-plan-form h3 {
    margin-bottom: 15px;
    color: #333;
}

.add-plan-form div {
    margin-bottom: 15px;
}

.add-plan-form label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
}

.add-plan-form input,
.add-plan-form select {
    width: 100%;
    padding: 8px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    font-size: 14px;
}

.add-plan-form input:focus,
.add-plan-form select:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.delete-button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.delete-button:hover {
    background-color: #c82333;
}

.add-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 20px;
}

.add-button:hover {
    background-color: #218838;
}

.disabled-input {
    background-color: #f5f5f5;
    color: #666;
    cursor: not-allowed;
}

.form-group input[type="checkbox"] {
    width: auto;
    margin-left: 10px;
}

.search-container {
    margin-bottom: 20px;
    padding: 15px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-input {
    width: 100%;
    padding: 12px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

.search-input:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.search-input::placeholder {
    color: #999;
}

.create-invoice-container {
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    max-width: 600px;
    margin: 20px auto;
}

.create-invoice-container h2 {
    color: #2c3e50;
    margin-bottom: 20px;
    text-align: center;
}

.invoice-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-group label {
    font-weight: 500;
    color: #2c3e50;
    font-size: 14px;
}

.form-input,
.form-select {
    padding: 10px 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.form-input:focus,
.form-select:focus {
    border-color: #409eff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(64,158,255,0.2);
}

.submit-button {
    background-color: #409eff;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.submit-button:hover {
    background-color: #66b1ff;
}

.submit-button:disabled {
    background-color: #a0cfff;
    cursor: not-allowed;
}

.form-input::placeholder {
    color: #c0c4cc;
}

/* Styles for CodeMirror container */
.codemirror-container {
  margin-bottom: 15px; /* Consistent margin with other inputs */
}

.codemirror-container .cm-editor {
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px; /* Match other inputs */
  outline: none; /* Remove default outline */
  transition: border-color 0.3s;
}

.codemirror-container .cm-editor.cm-focused {
  border-color: #007bff; /* Focus border color like other inputs */
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25); /* Optional focus shadow */
}

/* Styles for the informational note */
.codemirror-info {
  background-color: #f8f9fa; /* Light background */
  padding: 15px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #555;
}

.codemirror-info p {
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 500;
}

.codemirror-info ul {
  list-style-type: none; /* Remove default bullet points */
  padding-left: 0;
  margin-bottom: 0;
}

.codemirror-info li {
  margin-bottom: 5px;
}

.codemirror-info code {
  background-color: #e9ecef; /* Slightly darker background for code */
  padding: 2px 5px;
  border-radius: 3px;
  font-family: monospace;
}

/* Styles for Column Selector Row */
.column-selector-row {
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap to the next line if needed */
  gap: 15px; /* Spacing between items */
  margin-bottom: 15px; /* Space below the row */
  padding: 10px;
  background-color: #f8f9fa; /* Light background */
  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.column-selector-item {
  display: flex;
  align-items: center;
  /* Removed padding as gap is used in parent */
}

.column-selector-item input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
  width: auto; /* Override general input width */
}

.column-selector-item label {
  font-weight: normal; /* Override general label weight */
  margin-bottom: 0; /* Override general label margin */
  cursor: pointer;
  flex-grow: 1; /* Allow label to take space */
}

/* Styles for CreateInvoice component - reuse where possible */

/* Searchable Select specific styles */
.searchable-select-container {
    position: relative; /* Needed for absolute positioning of the list */
}

.searchable-list {
    position: absolute;
    top: 100%; /* Position below the input */
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #dcdfe6;
    border-top: none; /* Avoid double border */
    border-radius: 0 0 4px 4px;
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 10; /* Ensure list is above other elements */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.searchable-list li {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
}

.searchable-list li:hover {
    background-color: #f5f7fa;
}

.selected-info {
    font-size: 13px;
    color: #606266;
    margin-top: 5px;
    background-color: #f0f9eb; /* Light green background */
    border: 1px solid #e1f3d8;
    padding: 5px 8px;
    border-radius: 4px;
}
.selected-info strong {
    color: #555;
}

/* Payment Link display */
.payment-link-container {
    margin-top: 30px;
    padding: 15px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
}

.payment-link-container h3 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 16px;
    color: #333;
}

.link-display {
    display: flex;
    align-items: center;
    gap: 10px;
}

.link-input {
    flex-grow: 1;
    background-color: #fff; /* Make it look less like disabled */
    cursor: text;
    font-family: monospace;
    font-size: 13px;
}

.copy-button {
    padding: 10px 15px;
    background-color: #17a2b8; /* Info color */
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    white-space: nowrap; /* Prevent wrapping */
}

.copy-button:hover {
    background-color: #138496;
}

/* Adjustments for reused styles if needed */
.create-invoice-container .form-group label {
    margin-bottom: 5px; /* Slightly less margin */
}

/* Markups Management Styles */
.markups-container {
    padding: 20px;
}

.markup-form {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.markup-form .form-group {
    margin-bottom: 15px;
}

.markup-form label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
}

.markup-form input[type="text"],
.markup-form input[type="number"],
.markup-form textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.markup-form textarea {
    min-height: 100px;
    resize: vertical;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

.add-button {
    background-color: #4CAF50;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 20px;
}

.add-button:hover {
    background-color: #45a049;
}

.markups-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.markup-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.markup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.markup-header h3 {
    margin: 0;
    color: #333;
}

.status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
}

.status.active {
    background-color: #e8f5e9;
    color: #2e7d32;
}

.status.inactive {
    background-color: #ffebee;
    color: #c62828;
}

.description {
    color: #666;
    margin-bottom: 15px;
    font-size: 14px;
}

.markup-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    color: #666;
}

.value {
    font-weight: 500;
    color: #333;
}

.dates {
    font-size: 12px;
    color: #999;
}

.markup-actions {
    display: flex;
    gap: 10px;
}

.edit-button,
.delete-button {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.edit-button {
    background-color: #2196F3;
    color: white;
}

.edit-button:hover {
    background-color: #1976D2;
}

.delete-button {
    background-color: #f44336;
    color: white;
}

.delete-button:hover {
    background-color: #d32f2f;
}

.loading {
    text-align: center;
    padding: 20px;
    color: #666;
}

.mark-data {
    margin-top: 10px;
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #e9ecef;
}

.mark-data pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: monospace;
    font-size: 12px;
    color: #333;
}

.hash {
    font-family: monospace;
    font-size: 12px;
    color: #666;
    background-color: #f8f9fa;
    padding: 2px 6px;
    border-radius: 3px;
}

.markup-details p {
    margin: 5px 0;
    font-size: 14px;
}

.markup-details strong {
    color: #333;
    font-weight: 500;
}

/* Modal styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 40px;
    border-radius: 8px;
    width: 90%;
    max-width: 800px;
    max-height: 60vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.modal-header h3 {
    margin: 0;
    color: #333;
    font-size: 28px;
}

.close-button {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 0 8px;
}

.close-button:hover {
    color: #333;
}

.modal-body {
    margin-bottom: 40px;
}

.modal-body .form-group label {
    font-size: 18px;
    margin-bottom: 15px;
    display: block;
    font-weight: 500;
}

.codemirror-container {
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 15px;
}

.codemirror-container.invalid {
    border-color: #dc3545;
}

.codemirror-container .cm-editor {
    height: 400px;
}

.codemirror-container .cm-editor .cm-scroller {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
    font-size: 16px;
    line-height: 1.6;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 30px;
    border-top: 1px solid #eee;
}

.modal-footer button {
    padding: 12px 24px;
    font-size: 16px;
    min-width: 120px;
}

/* Updated Markups styles */
.markups-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.markups-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.markup-card {
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.markup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.markup-header h3 {
    margin: 0;
    color: #333;
    font-size: 16px;
}

.markup-actions {
    display: flex;
    gap: 8px;
}

.edit-button,
.delete-button {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
}

.edit-button {
    background-color: #007bff;
    color: white;
}

.edit-button:hover {
    background-color: #0056b3;
}

.delete-button {
    background-color: #dc3545;
    color: white;
}

.delete-button:hover {
    background-color: #c82333;
}

.admin-checkbox {
    width: 18px!important;
    height: 18px!important;
    cursor: pointer;
    position: relative;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: white;
    transition: all 0.2s ease;
}

.admin-checkbox:checked {
    background-color: #007bff;
    border-color: #007bff;
}

.admin-checkbox:checked::after {
    content: '';
    position: absolute;
    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.admin-checkbox:hover {
    border-color: #007bff;
}

.checkbox-field-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
}

.checkbox-field-container label {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

/* Tab Navigation */
.admin-tabs-nav {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #dee2e6;
}

.admin-tabs-nav button {
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-size: 16px;
  margin-right: 5px;
  border-bottom: 3px solid transparent;
  transition: color 0.3s ease, border-bottom-color 0.3s ease;
  color: #495057;
}

.admin-tabs-nav button:hover {
  color: #007bff;
}

.admin-tabs-nav button.active {
  color: #007bff;
  border-bottom-color: #007bff;
  font-weight: 600;
}

/* Style for users section if needed - for now, it can share styles with .settings-section or .plans-section */
.users-section {
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.users-section h2 {
  margin-bottom: 20px;
  color: #333;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 10px;
}

/* Minor adjustments for generate link container based on existing form styles */
.generate-link-container {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
}

.generate-link-container h3 {
    margin-bottom: 15px;
    color: #333;
}
.generate-link-container label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
}
.generated-link-display input {
    width: 100%; /* Ensure it takes full width if form-input doesn't cover it */
}

.clickable-cell:hover {
  text-decoration: underline;
  background-color: #f0f8ff; /* AliceBlue, a light and unintrusive hover color */
  color: #0056b3; /* Darker blue for text on hover for better contrast if needed */
}

/* Styles for EditUserEmailModal to make it more compact and refined */
.edit-user-email-modal .modal-content {
  padding: 25px;
  max-width: 500px; /* Make modal narrower */
  max-height: none; /* Allow content to define height, or set a specific one if needed */
}

.edit-user-email-modal .modal-header {
  margin-bottom: 20px; /* Reduced from 40px */
  padding-bottom: 15px; /* Reduced from 20px */
}

.edit-user-email-modal .modal-header h3 {
  font-size: 1.4rem; /* Reduced from 28px */
}

.edit-user-email-modal .close-button {
  font-size: 22px; /* Slightly smaller close button */
  padding: 0 5px; /* Adjust padding if needed */
}

.edit-user-email-modal .modal-body {
  margin-bottom: 25px; /* Reduced from 40px */
}

.edit-user-email-modal .modal-body .form-group {
  gap: 5px; /* Reduced gap between label and input */
}

.edit-user-email-modal .modal-body .form-group label {
  font-size: 0.9rem; /* Reduced from 18px */
  margin-bottom: 5px; /* Reduced from 15px */
  font-weight: 500;
}

.edit-user-email-modal .modal-body .form-input {
  padding: 8px 12px; /* Reduced padding */
  font-size: 0.9rem; /* Reduced font size */
}

.edit-user-email-modal .modal-footer {
  padding-top: 20px; /* Reduced from 30px */
  gap: 10px; /* Reduced gap between buttons */
}

.edit-user-email-modal .modal-footer button {
  padding: 8px 18px; /* Reduced padding */
  font-size: 0.9rem; /* Reduced font size */
  min-width: auto; /* Allow button to size naturally or set a smaller min-width e.g., 90px */
}

/* Ensure cancel button has distinct styling if not already generic */
.edit-user-email-modal .cancel-button {
    background-color: #6c757d; /* Example: Bootstrap secondary color */
    color: white;
}

.edit-user-email-modal .cancel-button:hover {
    background-color: #5a6268;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.clickable-row:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

`, "",{"version":3,"sources":["webpack://./src/components/Admin/Admin.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe,EAAE,uBAAuB;EACxC,aAAa,EAAE,2BAA2B;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB,EAAE,yCAAyC;EAChE,0CAA0C,EAAE,0BAA0B;AACxE;;AAEA,sCAAsC;AACtC;EACE,yBAAyB,EAAE,qBAAqB;EAChD,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB,EAAE,iCAAiC;EACxD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe,EAAE,mDAAmD;EACpE,SAAS,EAAE,0BAA0B;EACrC,mBAAmB,EAAE,wBAAwB;EAC7C,aAAa;EACb,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW,EAAE,iCAAiC;AAChD;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;EACvD,gBAAgB,EAAE,kCAAkC;EACpD,eAAe;EACf,YAAY,EAAE,8BAA8B;AAC9C;;AAEA,8DAA8D;;AAE9D,sCAAsC;AACtC;IACI,kBAAkB,EAAE,gDAAgD;AACxE;;AAEA;IACI,kBAAkB;IAClB,SAAS,EAAE,6BAA6B;IACxC,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB,EAAE,wBAAwB;IAC1C,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,WAAW,EAAE,wCAAwC;IACrD,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB,EAAE,2BAA2B;IACtD,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,sBAAsB,EAAE,oCAAoC;IAC5D,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB,EAAE,eAAe;IAC1C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,mBAAmB,EAAE,qBAAqB;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB,EAAE,yBAAyB;AACjD;;AAEA,8BAA8B;AAC9B;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uFAAuF;IACvF,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8GAA8G;AAC9G;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,gFAAgF;AAChF;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW,EAAE,8DAA8D;AAC/E;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB,EAAE,mDAAmD;EAC9E,cAAc,EAAE,gEAAgE;AAClF;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,gBAAgB,EAAE,wBAAwB;EAC1C,gBAAgB,EAAE,oEAAoE;AACxF;;AAEA;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,oBAAoB,EAAE,sBAAsB;AAC9C;;AAEA;EACE,iBAAiB,EAAE,sBAAsB;AAC3C;;AAEA;EACE,eAAe,EAAE,kCAAkC;EACnD,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,QAAQ,EAAE,wCAAwC;AACpD;;AAEA;EACE,iBAAiB,EAAE,sBAAsB;EACzC,kBAAkB,EAAE,sBAAsB;EAC1C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,oBAAoB;EACvC,iBAAiB,EAAE,sBAAsB;AAC3C;;AAEA;EACE,iBAAiB,EAAE,sBAAsB;EACzC,SAAS,EAAE,gCAAgC;AAC7C;;AAEA;EACE,iBAAiB,EAAE,oBAAoB;EACvC,iBAAiB,EAAE,sBAAsB;EACzC,eAAe,EAAE,yEAAyE;AAC5F;;AAEA,qEAAqE;AACrE;IACI,yBAAyB,EAAE,uCAAuC;IAClE,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".admin-container {\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.admin-container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.admin-container form {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-container label {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.admin-container textarea,\n.admin-container input,\n.admin-container select {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.3s;\n  box-sizing: border-box;\n}\n\n.admin-container textarea {\n  min-height: 150px;\n  max-height: 350px;\n  resize: vertical;\n}\n\n.admin-container textarea:focus,\n.admin-container input:focus,\n.admin-container select:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.admin-container button {\n  padding: 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.admin-container button:hover {\n  background-color: #0056b3;\n}\n\n.subscriptions-table-container {\n    margin-top: 20px;\n    overflow-x: auto;\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.subscriptions-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n    font-size: 12px;\n}\n\n.subscriptions-table th,\n.subscriptions-table td {\n    border: 1px solid #ddd;\n    padding: 6px 8px;\n    text-align: left;\n}\n\n.subscriptions-table th {\n    position: sticky;\n    top: 0;\n    background-color: #f4f4f4;\n    z-index: 1;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.subscriptions-table th:hover {\n    background-color: #e4e4e4;\n}\n\n.subscriptions-table tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\n.subscriptions-table tr:hover {\n    background-color: #f5f5f5;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    gap: 5px;\n}\n\n.pagination-button {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    background-color: white;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: all 0.3s;\n    min-width: 40px;\n    font-weight: 500;\n}\n\n.pagination-button:hover:not(:disabled) {\n    background-color: #0059b9;\n}\n\n.pagination-button.active {\n    background-color: #00356e;\n    color: white;\n    border-color: #007bff;\n    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);\n    font-weight: bold;\n}\n\n.pagination-button.active:hover {\n    background-color: #0056b3;\n}\n\n.pagination-button:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.items-per-page {\n    margin-left: 15px;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.action-buttons {\n    white-space: nowrap;\n    width: 80px;\n}\n\n.action-buttons button {\n    padding: 4px 8px;\n    margin: 0 2px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.edit-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.edit-button:hover {\n    background-color: #0056b3;\n}\n\n.save-button:hover {\n    color: #28a745;\n}\n\n.cancel-button:hover {\n    color: #dc3545;\n}\n\n.subscriptions-table input,\n.subscriptions-table select {\n    width: 100%;\n    padding: 4px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.subscriptions-table input:focus,\n.subscriptions-table select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n.subscriptions-table td {\n    max-width: 100px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.editable-row {\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.editable-row:hover {\n    background-color: rgba(0, 123, 255, 0.05);\n}\n\n.editable-row td {\n    user-select: none; \n}\n\n.subscriptions-table th:nth-child(1),\n.subscriptions-table td:nth-child(1) {\n    width: 80px;\n    font-family: monospace;\n    font-size: 12px;\n    text-align: center;\n}\n\n.admin-layout {\n    display: flex;\n    min-height: 100vh;\n    background-color: #f9f9f9;\n}\n\n.admin-nav {\n    width: 250px;\n    min-width: 250px;\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-right: 1px solid #dee2e6;\n    height: 100vh;\n    position: fixed;\n    left: 0;\n    top: 0;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.admin-nav h2 {\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #dee2e6;\n    color: #333;\n    font-size: 1.5rem;\n}\n\n.nav-link {\n    display: block;\n    padding: 12px 15px;\n    color: #333;\n    text-decoration: none;\n    border-radius: 4px;\n    margin-bottom: 8px;\n    transition: all 0.3s ease;\n}\n\n.nav-link:hover {\n    background-color: #e9ecef;\n}\n\n.nav-link.active {\n    background-color: #007bff;\n    color: white;\n}\n\n.admin-content {\n    flex: 1;\n    padding: 30px;\n    margin-left: 250px;\n    width: calc(100% - 250px);\n    box-sizing: border-box;\n}\n\n.settings-section,\n.plans-section {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n}\n\n.settings-section h2,\n.plans-section h2 {\n    margin-bottom: 20px;\n    color: #333;\n    border-bottom: 1px solid #dee2e6;\n    padding-bottom: 10px;\n}\n\n.plans-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n    font-size: 14px;\n}\n\n.plans-table th,\n.plans-table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.plans-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n}\n\n.plans-table tr:hover {\n    background-color: #f8f9fa;\n}\n\n.add-plan-form {\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 20px;\n}\n\n.add-plan-form h3 {\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.add-plan-form div {\n    margin-bottom: 15px;\n}\n\n.add-plan-form label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 500;\n}\n\n.add-plan-form input,\n.add-plan-form select {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.add-plan-form input:focus,\n.add-plan-form select:focus {\n    border-color: #007bff;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.delete-button {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.delete-button:hover {\n    background-color: #c82333;\n}\n\n.add-button {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.add-button:hover {\n    background-color: #218838;\n}\n\n.disabled-input {\n    background-color: #f5f5f5;\n    color: #666;\n    cursor: not-allowed;\n}\n\n.form-group input[type=\"checkbox\"] {\n    width: auto;\n    margin-left: 10px;\n}\n\n.search-container {\n    margin-bottom: 20px;\n    padding: 15px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.search-input {\n    width: 100%;\n    padding: 12px;\n    font-size: 14px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    transition: all 0.3s ease;\n    box-sizing: border-box;\n}\n\n.search-input:focus {\n    border-color: #007bff;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.search-input::placeholder {\n    color: #999;\n}\n\n.create-invoice-container {\n    padding: 20px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    max-width: 600px;\n    margin: 20px auto;\n}\n\n.create-invoice-container h2 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.invoice-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.form-group label {\n    font-weight: 500;\n    color: #2c3e50;\n    font-size: 14px;\n}\n\n.form-input,\n.form-select {\n    padding: 10px 12px;\n    border: 1px solid #dcdfe6;\n    border-radius: 4px;\n    font-size: 14px;\n    transition: all 0.3s ease;\n}\n\n.form-input:focus,\n.form-select:focus {\n    border-color: #409eff;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(64,158,255,0.2);\n}\n\n.submit-button {\n    background-color: #409eff;\n    color: white;\n    border: none;\n    padding: 12px;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.submit-button:hover {\n    background-color: #66b1ff;\n}\n\n.submit-button:disabled {\n    background-color: #a0cfff;\n    cursor: not-allowed;\n}\n\n.form-input::placeholder {\n    color: #c0c4cc;\n}\n\n/* Styles for CodeMirror container */\n.codemirror-container {\n  margin-bottom: 15px; /* Consistent margin with other inputs */\n}\n\n.codemirror-container .cm-editor {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px; /* Match other inputs */\n  outline: none; /* Remove default outline */\n  transition: border-color 0.3s;\n}\n\n.codemirror-container .cm-editor.cm-focused {\n  border-color: #007bff; /* Focus border color like other inputs */\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25); /* Optional focus shadow */\n}\n\n/* Styles for the informational note */\n.codemirror-info {\n  background-color: #f8f9fa; /* Light background */\n  padding: 15px;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  color: #555;\n}\n\n.codemirror-info p {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-weight: 500;\n}\n\n.codemirror-info ul {\n  list-style-type: none; /* Remove default bullet points */\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.codemirror-info li {\n  margin-bottom: 5px;\n}\n\n.codemirror-info code {\n  background-color: #e9ecef; /* Slightly darker background for code */\n  padding: 2px 5px;\n  border-radius: 3px;\n  font-family: monospace;\n}\n\n/* Styles for Column Selector Row */\n.column-selector-row {\n  display: flex;\n  flex-wrap: wrap; /* Allow items to wrap to the next line if needed */\n  gap: 15px; /* Spacing between items */\n  margin-bottom: 15px; /* Space below the row */\n  padding: 10px;\n  background-color: #f8f9fa; /* Light background */\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n}\n\n.column-selector-item {\n  display: flex;\n  align-items: center;\n  /* Removed padding as gap is used in parent */\n}\n\n.column-selector-item input[type=\"checkbox\"] {\n  margin-right: 8px;\n  cursor: pointer;\n  width: auto; /* Override general input width */\n}\n\n.column-selector-item label {\n  font-weight: normal; /* Override general label weight */\n  margin-bottom: 0; /* Override general label margin */\n  cursor: pointer;\n  flex-grow: 1; /* Allow label to take space */\n}\n\n/* Styles for CreateInvoice component - reuse where possible */\n\n/* Searchable Select specific styles */\n.searchable-select-container {\n    position: relative; /* Needed for absolute positioning of the list */\n}\n\n.searchable-list {\n    position: absolute;\n    top: 100%; /* Position below the input */\n    left: 0;\n    right: 0;\n    background-color: white;\n    border: 1px solid #dcdfe6;\n    border-top: none; /* Avoid double border */\n    border-radius: 0 0 4px 4px;\n    max-height: 200px;\n    overflow-y: auto;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    z-index: 10; /* Ensure list is above other elements */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.searchable-list li {\n    padding: 8px 12px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.searchable-list li:hover {\n    background-color: #f5f7fa;\n}\n\n.selected-info {\n    font-size: 13px;\n    color: #606266;\n    margin-top: 5px;\n    background-color: #f0f9eb; /* Light green background */\n    border: 1px solid #e1f3d8;\n    padding: 5px 8px;\n    border-radius: 4px;\n}\n.selected-info strong {\n    color: #555;\n}\n\n/* Payment Link display */\n.payment-link-container {\n    margin-top: 30px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border: 1px solid #e9ecef;\n    border-radius: 4px;\n}\n\n.payment-link-container h3 {\n    margin-top: 0;\n    margin-bottom: 15px;\n    font-size: 16px;\n    color: #333;\n}\n\n.link-display {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.link-input {\n    flex-grow: 1;\n    background-color: #fff; /* Make it look less like disabled */\n    cursor: text;\n    font-family: monospace;\n    font-size: 13px;\n}\n\n.copy-button {\n    padding: 10px 15px;\n    background-color: #17a2b8; /* Info color */\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    white-space: nowrap; /* Prevent wrapping */\n}\n\n.copy-button:hover {\n    background-color: #138496;\n}\n\n/* Adjustments for reused styles if needed */\n.create-invoice-container .form-group label {\n    margin-bottom: 5px; /* Slightly less margin */\n}\n\n/* Markups Management Styles */\n.markups-container {\n    padding: 20px;\n}\n\n.markup-form {\n    background: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 20px;\n}\n\n.markup-form .form-group {\n    margin-bottom: 15px;\n}\n\n.markup-form label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 500;\n}\n\n.markup-form input[type=\"text\"],\n.markup-form input[type=\"number\"],\n.markup-form textarea {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.markup-form textarea {\n    min-height: 100px;\n    resize: vertical;\n}\n\n.form-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.add-button {\n    background-color: #4CAF50;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.add-button:hover {\n    background-color: #45a049;\n}\n\n.markups-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n}\n\n.markup-card {\n    background: #fff;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.markup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.markup-header h3 {\n    margin: 0;\n    color: #333;\n}\n\n.status {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.status.active {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n}\n\n.status.inactive {\n    background-color: #ffebee;\n    color: #c62828;\n}\n\n.description {\n    color: #666;\n    margin-bottom: 15px;\n    font-size: 14px;\n}\n\n.markup-details {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n    font-size: 14px;\n    color: #666;\n}\n\n.value {\n    font-weight: 500;\n    color: #333;\n}\n\n.dates {\n    font-size: 12px;\n    color: #999;\n}\n\n.markup-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.edit-button,\n.delete-button {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.edit-button {\n    background-color: #2196F3;\n    color: white;\n}\n\n.edit-button:hover {\n    background-color: #1976D2;\n}\n\n.delete-button {\n    background-color: #f44336;\n    color: white;\n}\n\n.delete-button:hover {\n    background-color: #d32f2f;\n}\n\n.loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n}\n\n.mark-data {\n    margin-top: 10px;\n    background-color: #f8f9fa;\n    padding: 10px;\n    border-radius: 4px;\n    border: 1px solid #e9ecef;\n}\n\n.mark-data pre {\n    margin: 0;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    font-family: monospace;\n    font-size: 12px;\n    color: #333;\n}\n\n.hash {\n    font-family: monospace;\n    font-size: 12px;\n    color: #666;\n    background-color: #f8f9fa;\n    padding: 2px 6px;\n    border-radius: 3px;\n}\n\n.markup-details p {\n    margin: 5px 0;\n    font-size: 14px;\n}\n\n.markup-details strong {\n    color: #333;\n    font-weight: 500;\n}\n\n/* Modal styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    padding: 40px;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 800px;\n    max-height: 60vh;\n    overflow-y: auto;\n    position: relative;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #eee;\n}\n\n.modal-header h3 {\n    margin: 0;\n    color: #333;\n    font-size: 28px;\n}\n\n.close-button {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #666;\n    padding: 0 8px;\n}\n\n.close-button:hover {\n    color: #333;\n}\n\n.modal-body {\n    margin-bottom: 40px;\n}\n\n.modal-body .form-group label {\n    font-size: 18px;\n    margin-bottom: 15px;\n    display: block;\n    font-weight: 500;\n}\n\n.codemirror-container {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    overflow: hidden;\n    margin-bottom: 15px;\n}\n\n.codemirror-container.invalid {\n    border-color: #dc3545;\n}\n\n.codemirror-container .cm-editor {\n    height: 400px;\n}\n\n.codemirror-container .cm-editor .cm-scroller {\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;\n    font-size: 16px;\n    line-height: 1.6;\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n    padding-top: 30px;\n    border-top: 1px solid #eee;\n}\n\n.modal-footer button {\n    padding: 12px 24px;\n    font-size: 16px;\n    min-width: 120px;\n}\n\n/* Updated Markups styles */\n.markups-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.markups-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n}\n\n.markup-card {\n    background: white;\n    border-radius: 8px;\n    padding: 15px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.markup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.markup-header h3 {\n    margin: 0;\n    color: #333;\n    font-size: 16px;\n}\n\n.markup-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.edit-button,\n.delete-button {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.2s;\n}\n\n.edit-button {\n    background-color: #007bff;\n    color: white;\n}\n\n.edit-button:hover {\n    background-color: #0056b3;\n}\n\n.delete-button {\n    background-color: #dc3545;\n    color: white;\n}\n\n.delete-button:hover {\n    background-color: #c82333;\n}\n\n.admin-checkbox {\n    width: 18px!important;\n    height: 18px!important;\n    cursor: pointer;\n    position: relative;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    transition: all 0.2s ease;\n}\n\n.admin-checkbox:checked {\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.admin-checkbox:checked::after {\n    content: '';\n    position: absolute;\n    left: 5px;\n    top: 2px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.admin-checkbox:hover {\n    border-color: #007bff;\n}\n\n.checkbox-field-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n\n.checkbox-field-container label {\n    cursor: pointer;\n    user-select: none;\n}\n\n/* Tab Navigation */\n.admin-tabs-nav {\n  display: flex;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.admin-tabs-nav button {\n  padding: 10px 20px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  font-size: 16px;\n  margin-right: 5px;\n  border-bottom: 3px solid transparent;\n  transition: color 0.3s ease, border-bottom-color 0.3s ease;\n  color: #495057;\n}\n\n.admin-tabs-nav button:hover {\n  color: #007bff;\n}\n\n.admin-tabs-nav button.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n  font-weight: 600;\n}\n\n/* Style for users section if needed - for now, it can share styles with .settings-section or .plans-section */\n.users-section {\n  background: white;\n  padding: 10px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.users-section h2 {\n  margin-bottom: 20px;\n  color: #333;\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 10px;\n}\n\n/* Minor adjustments for generate link container based on existing form styles */\n.generate-link-container {\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 20px;\n}\n\n.generate-link-container h3 {\n    margin-bottom: 15px;\n    color: #333;\n}\n.generate-link-container label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 500;\n}\n.generated-link-display input {\n    width: 100%; /* Ensure it takes full width if form-input doesn't cover it */\n}\n\n.clickable-cell:hover {\n  text-decoration: underline;\n  background-color: #f0f8ff; /* AliceBlue, a light and unintrusive hover color */\n  color: #0056b3; /* Darker blue for text on hover for better contrast if needed */\n}\n\n/* Styles for EditUserEmailModal to make it more compact and refined */\n.edit-user-email-modal .modal-content {\n  padding: 25px;\n  max-width: 500px; /* Make modal narrower */\n  max-height: none; /* Allow content to define height, or set a specific one if needed */\n}\n\n.edit-user-email-modal .modal-header {\n  margin-bottom: 20px; /* Reduced from 40px */\n  padding-bottom: 15px; /* Reduced from 20px */\n}\n\n.edit-user-email-modal .modal-header h3 {\n  font-size: 1.4rem; /* Reduced from 28px */\n}\n\n.edit-user-email-modal .close-button {\n  font-size: 22px; /* Slightly smaller close button */\n  padding: 0 5px; /* Adjust padding if needed */\n}\n\n.edit-user-email-modal .modal-body {\n  margin-bottom: 25px; /* Reduced from 40px */\n}\n\n.edit-user-email-modal .modal-body .form-group {\n  gap: 5px; /* Reduced gap between label and input */\n}\n\n.edit-user-email-modal .modal-body .form-group label {\n  font-size: 0.9rem; /* Reduced from 18px */\n  margin-bottom: 5px; /* Reduced from 15px */\n  font-weight: 500;\n}\n\n.edit-user-email-modal .modal-body .form-input {\n  padding: 8px 12px; /* Reduced padding */\n  font-size: 0.9rem; /* Reduced font size */\n}\n\n.edit-user-email-modal .modal-footer {\n  padding-top: 20px; /* Reduced from 30px */\n  gap: 10px; /* Reduced gap between buttons */\n}\n\n.edit-user-email-modal .modal-footer button {\n  padding: 8px 18px; /* Reduced padding */\n  font-size: 0.9rem; /* Reduced font size */\n  min-width: auto; /* Allow button to size naturally or set a smaller min-width e.g., 90px */\n}\n\n/* Ensure cancel button has distinct styling if not already generic */\n.edit-user-email-modal .cancel-button {\n    background-color: #6c757d; /* Example: Bootstrap secondary color */\n    color: white;\n}\n\n.edit-user-email-modal .cancel-button:hover {\n    background-color: #5a6268;\n}\n\n.clickable-row {\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.clickable-row:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
